import React from "react";
import { Box, Text, Inline, Hidden, IconHome } from "braid-design-system";
import LogoutButton from "./LogoutButton";
import LanguageSwitcher from "./LanguageSwitcher";
import { useAuth } from "../contexts/AuthProvider";

const TopBar: React.FC = () => {
    const { user, loggedInAt } = useAuth();
    const branchLabel = String(user?.active_branch?.loc_desc ?? user?.active_branch?.loc_code ?? "").trim();

    const loggedInLabel = React.useMemo(() => {
        if (!loggedInAt) {
            return null;
        }

        const loginDate = new Date(loggedInAt);
        if (Number.isNaN(loginDate.getTime())) {
            return null;
        }

        const time = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        }).format(loginDate);

        const date = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).format(loginDate);

        return `Logged in at: ${time}  ${date}`;
    }, [loggedInAt]);

    return (
        <Box paddingY={['xsmall', 'xsmall', 'xsmall', 'xsmall']} paddingX={['xsmall', 'small', 'large', 'large']}>
            <Inline space={['small', 'small', 'large', 'large']} alignY="center">
                <Inline space="small" alignY="center">
                    <Text weight="strong" size="standard">
                        {
                            user?.institute?.name_ln1
                        }
                    </Text>
                    <Hidden below="tablet">
                        <Inline space="small" alignY="center">
                            <Text size="small" icon={<IconHome />}>
                                {branchLabel}
                            </Text>
                        </Inline>
                    </Hidden>
                </Inline>
                <Box flexGrow={1} />
                <LanguageSwitcher />
                <Hidden below="tablet">
                    {loggedInLabel ? (
                        <Box paddingRight="small">
                            <Text size="small" tone="secondary">
                                {loggedInLabel}
                            </Text>
                        </Box>
                    ) : null}
                </Hidden>
                <LogoutButton />
            </Inline>

        </Box>
    );
};

export default TopBar;
